export default __webpack_public_path__ + "static/media/fanghaus-open.7b020ab8.png";